import { useCategorias } from "@/hooks/useCategorias";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Tag } from "lucide-react";

export const CategoriasTab = () => {
  const { categories, loading, showNew, setShowNew, newName, setNewName, createCategory } = useCategorias();

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-muted-foreground">Categorías para clasificar movimientos</p>
        <Dialog open={showNew} onOpenChange={setShowNew}>
          <DialogTrigger asChild>
            <Button className="gap-2 glow-orange"><Plus className="w-4 h-4" />Nueva Categoría</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nueva Categoría</DialogTitle></DialogHeader>
            <Input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nombre" className="bg-secondary border-transparent" />
            <DialogFooter><Button onClick={createCategory}>Crear</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      {loading ? <LoadingScreen /> : (
        <div className="grid gap-2">
          {categories.map(c => (
            <Card key={c.id} className="card-hover">
              <CardContent className="flex items-center gap-3 p-3">
                <Tag className="w-4 h-4 text-muted-foreground" />
                <span className="text-sm font-medium">{c.name}</span>
                <Badge variant="outline" className="ml-auto">{c.type}</Badge>
              </CardContent>
            </Card>
          ))}
          {categories.length === 0 && <p className="text-center text-muted-foreground py-8">Sin categorías</p>}
        </div>
      )}
    </div>
  );
};
